import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getAPIMultipleAnswer = (params) => {
	const url = ApiRouters.API_MULTIPLE_ANSWER;
	return api.get(url, { params });
};

export const postAPIMultipleAnswer = (body) => {
	const url = ApiRouters.API_MULTIPLE_ANSWER;
	return api.post(url, body);
};

export const getAPIMultipleAnswerDetail = (id) => {
	const url = `${ApiRouters.API_MULTIPLE_ANSWER}/${id}`;
	return api.get(url);
};

export const putAPIMultipleAnswerDetail = (id, body) => {
	const url = `${ApiRouters.API_MULTIPLE_ANSWER}/${id}`;
	return api.put(url, body);
}

export const deleteAPIMultipleAnswer = (id) => {
	const url = `${ApiRouters.API_MULTIPLE_ANSWER}/${id}`;
	return api.delete(url);
};

// export const getReadAloudDetail = (id, params) => {
// 	const url = `${ApiRouters.READALOUD}/${id}`;
// 	return api.get(url, { params });
// };

// export const createQuesReadAloud = (body) => {
// 	const url = ApiRouters.READALOUD;
// 	return api.post(url, body);
// };

// export const updateReadAloudDetail = (body) => {
// 	const url = `${ApiRouters.READALOUD}/${body.id}`;
// 	return api.put(url, body);
// };